import { initializeVueComponent } from './../assets/utils/vue.js';
import TgCompleteLogin from '@topgeschenken/webshop-front/components/auth/TgCompleteLogin'
import './../assets/scss/_layout/_webshop-front.scss'
import './../assets/scss/login-register.scss'

(function() {
    initializeVueComponent('#customer_login_app', TgCompleteLogin)
})()